var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cgv-page", attrs: { id: "cms" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "cmsContent container" }, [
        _vm.shop
          ? _c("h1", [
              _vm._v(
                "Conditions générales de prestation de service " +
                  _vm._s(_vm.shop.DefaultName)
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shop
          ? _c("p", [
              _vm._v(
                "Bienvenue sur notre site web " +
                  _vm._s(_vm.location.hostname + "/" + _vm.shop.ShopId) +
                  ' et dans nos applications (notre "Service" ). Cette page (avec les documents auxquels elle fait référence) présente les conditions auxquelles nos restaurants partenaires vous fournissent leurs repas (les "Repas1" ) figurant sur notre site internet.'
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            " Merci de lire attentivement ces conditions avant de commander des Repas sur notre site. En accédant à notre site et en passant une commande, vous acceptez d'être lié sans réserve par les présentes conditions et par notre politique de conditions d'utilisation."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            " Si vous avez des questions au sujet de ces conditions, veuillez prendre contact avec nous avant de passer commande. Si vous n'acceptez pas intégralement ces conditions, n'utilisez pas notre Service."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v(" 1. A NOTRE SUJET")]),
        _vm._v(" "),
        _vm.shop
          ? _c("p", [
              _vm._v(
                _vm._s(_vm.location.hostname + "/" + _vm.shop.ShopId) +
                  ' est un site web exploité par Sud Informatique Services ("nous" ou "CLYO SYSTEMS"), société sous la forme SARL, au capital de 10 000 euros dont le siège social est situé 60 Avenue de Nice, Cagnes sur mer, 06100, France, et immatriculée au RCS en France sous le n° 489 418 053 '
              ),
              _c("br"),
              _vm._v("\n Notre numéro de TVA FR91489418053 "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("h2", [_vm._v(" 2. OBJECTIF")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Notre Service a pour but la fourniture d'un service simple et pratique en vous mettant en relation avec le Restaurant partenaire et le menu de son choix et en vous permettant de lui passer commande de Repas. SUD INFORMATIQUE SERVICES commercialise des Repas pour le compte de ses Restaurants partenaires, prend les commandes pour leur compte et vous livre les Repas."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("3. DISPONIBILITE DES SERVICES")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "SUD INFORMATIQUE SERVICES propose un Service de passation de commandes et de livraison de ses Restaurants partenaires à Paris. Chaque restaurant partenaire a un secteur de livraison défini, afin de garantir que ses Repas arrivent chez vous dans les meilleures conditions possibles. Si vous habitez en dehors des secteurs de livraison, un message apparaît à l'écran pour indiquer que votre passation de commande en ligne sera impossible. Nous n'acceptons pas les commandes de personnes dont le code postal est celui d'une commune où nous n'avons aucun restaurant partenaire. Les heures d'ouverture varient en fonction des habitudes commerciales locales et de la disponibilité de nos Restaurants partenaires. Veuillez cliquer sur le lien pour voir les menus, leurs caractéristiques, et les prix de notre Service puis cliquez sur le menu que vous avez choisi, ce qui vous donnera la possibilité de passer votre commande au restaurant partenaire que vous avez choisi."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v(" 4. COMMANDES")]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("h2", [_vm._v("5. REPAS")]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("h2", [_vm._v("6. VENTE D'ALCOOL")]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _c("h2", [_vm._v("7. DISPONIBILITE ET LIVRAISON")]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("h2", [_vm._v("8. ANNULATION")]),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _c("h2", [_vm._v("9. PRIX ET REGLEMENT")]),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous sommes autorisés par nos Restaurants partenaires à accepter le règlement pour leur compte et le règlement du prix de Repas à notre bénéfice vous dégage de vos obligations de payer ce prix au Restaurant partenaire."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("10. NOTRE RESPONSABILITE")]),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _c("h2", [_vm._v("11. EVENEMENTS INDEPENDANTS DE NOTRE VOLONTE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Aucune partie n'est responsable vis-à-vis de l'autre d'un retard ou d'une absence d'exécution de ses obligations aux termes du présent contrat si ledit retard ou ladite absence est indépendant(e) de sa volonté dont, de manière non exhaustive, les événements suivants : catastrophe naturelle, disposition gouvernementale, guerre, incendie, inondation, explosion ou mouvements populaires. Pour éviter tout doute, rien dans la clause 11 n'autorise le client à ne pas s'acquitter de ses obligations de règlement aux termes du présent contrat."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("12. RENONCIATION")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Ni vous, ni SUD INFORMATIQUE SERVICES , ni le Restaurant partenaire n'êtes responsables vis-à-vis des autres parties d'un retard ou d'une absence d'exécution de ses obligations aux termes du présent contrat si ledit retard ou ladite absence est indépendant(e) de sa volonté dont, de manière non exhaustive, les événements suivants : catastrophe naturelle, disposition gouvernementale, guerre, incendie, inondation, explosion ou mouvements populaires."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("13. DISJONCTION")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Si une disposition du présent contrat est jugée illégale ou inapplicable, la force exécutoire intégrale des autres dispositions demeure."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("14. CONTRAT INDIVISIBLE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les présentes conditions contiennent l'intégralité du contrat entre les parties relatif à son objet et remplacent l'ensemble des contrats et accords antérieurs entre les parties relatifs à cet objet."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("15. NOTRE DROIT DE MODIFIER CES CONDITIONS")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "SUD INFORMATIQUE SERVICES peut réviser les présentes conditions à tout moment en modifiant cette page. Vous êtes censé vérifier cette page de temps à autre pour prendre connaissance des modifications que nous avons apportées car elles sont contraignantes pour vous."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("16. DROIT ET COMPETENCE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les tribunaux français ont compétence pour toutes les plaintes découlant de ou liées à une utilisation de nos Services. Les présentes conditions d'utilisation et tout conflit ou plainte découlant de ou lié(e) à ces conditions d'utilisation ou leur objet ou formation (dont les conflits ou plaintes non contractuel(le)s) doivent être régis par et interprétés conformément au droit français. Conformément aux dispositions du Code de la consommation, il vous est possible de recourir à un mode alternatif de règlement des litiges ou à une procédure de médiation conventionnelle. La recherche d’une telle solution amiable interrompt les délais pour agir. A défaut, la juridiction compétente sera déterminée par les règles de droit commun."
          ),
        ]),
        _vm._v(" "),
        _c("h1", [
          _vm._v(
            " Conditions d'utilisation de SUD INFORMATIQUE SERVICES pour le site web et les applications"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Cette page (en association avec les documents auxquels elle fait référence) présente les conditions d'utilisation qui vous permettent d'utiliser notre site web www.clyosystems.com (notre \"Site\") ou les applications que nous mettons à disposition par le biais d'une boutique d'applications ou autre (notre \"Service\"), que ce soit comme hôte ou comme utilisateur inscrit. Veuillez lire attentivement ces conditions d'utilisation avant de commencer à utiliser notre Site ou notre Service. En accédant à notre Site ou en utilisant notre Service, vous indiquez que vous acceptez ces conditions d'utilisation et que vous vous engagez à les respecter. Si vous n'êtes pas d'accord avec ces conditions d'utilisation, n'accédez pas à notre Site ou n'utilisez pas notre Service."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("1. A NOTRE SUJET")]),
        _vm._v(" "),
        _vm._m(10),
        _vm._v(" "),
        _c("h2", [_vm._v("2. ACCES A NOTRE SITE OU A NOS SERVICES")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "L'accès à notre Site et à notre Service est autorisé de manière temporaire et nous nous réservons le droit de supprimer ou de modifier sans préavis l'accès à notre Site ou à notre Service (voir ci-dessous). Nous ne sommes pas responsables si, pour quelque motif que ce soit, notre Site ou notre Service n'est pas disponible à un moment donné ou pendant une période donnée. Le cas échéant, nous pouvons limiter l'accès à certaines parties de notre Site ou de notre Service ou l’accès à l'ensemble de notre Site ou Service aux utilisateurs inscrits. Vous êtes responsable de la préservation de la confidentialité de vos informations de connexion et des activités de votre compte. Si vous avez des inquiétudes au sujet de vos informations de connexion ou si vous pensez qu'elles ont été piratées, prenez immédiatement contact avec contact@clyosystems.com pour nous en informer. Nous pouvons désactiver votre compte à tout moment."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("3. UTILISATION ACCEPTABLE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Vous ne pouvez utiliser notre Service qu'à des fins légales. Vous ne pouvez utiliser notre Site ou notre Service d'aucune manière qui contrevienne à une loi ou réglementation locale, nationale ou internationale applicable ni pour envoyer, recevoir sciemment, télécharger, utiliser ou réutiliser des éléments qui ne sont pas conformes à nos normes en matière de contenu figurant dans la clause 5 ci-dessous. Vous vous engagez également à ne pas accéder sans autorisation à, endommager ou perturber une partie de notre Site ou de notre Service ou un réseau ou un matériel utilisé dans la fourniture de notre Service."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("4. FONCTIONS INTERACTIVES DE NOTRE SITE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous pouvons le cas échéant offrir des fonctions qui vous permettent d'interagir par le biais de notre Site ou de notre Service, comme des groupes de discussion. En règle générale, nous ne modérons aucun Service interactif que nous fournissons, bien que nous puissions supprimer un contenu qui ne respecterait pas ces conditions d'utilisation, conformément aux dispositions de la section 6. Si nous décidons de modérer un Service interactif, nous le mentionnons clairement avant que vous utilisiez le Service et vous offrons normalement un moyen de prendre contact avec l'animateur en cas de doute ou de difficulté."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("5. NORMES EN MATIERE DE CONTENU")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Ces normes en matière de contenu s'appliquent à tous les éléments par lesquels vous contribuez à notre Service (les \"Contributions\") et aux éventuels Services interactifs qui y sont associés. Vous devez respecter l'esprit et la lettre des normes suivantes. Les normes s'appliquent à chaque partie des Contributions et à leur globalité. Les Contributions doivent être précises (lorsqu'elles exposent des faits), être sincères (lorsqu'elles exposent des convictions) et respecter la législation applicable en France et dans le pays d'où elles sont émises. Les Contributions ne doivent pas :"
          ),
        ]),
        _vm._v(" "),
        _vm._m(11),
        _vm._v(" "),
        _c("h2", [_vm._v("6. SUSPENSION ET RESILIATION")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Le non-respect de la section 3 (Utilisation acceptable) et/ou 5 (Normes en matière de contenu) des présentes conditions d'utilisation constitue une violation déterminante des conditions d'utilisation et peut nous amener à prendre tout ou partie des mesures suivantes :"
          ),
        ]),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _c("h2", [_vm._v("7. DROITS DE PROPRIETE INTELLECTUELLE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous sommes le propriétaire ou le détenteur de licence de tous les droits de propriété intellectuelle de notre Site et de notre Service et des éléments publiés sur ce Site (à l'exception de vos contributions). Ces travaux sont protégés par les lois et traités sur le droit d'auteur dans le monde entier. Tous ces droits sont réservés. Vous n'avez pas le droit de copier, reproduire, republier, télécharger, envoyer, diffuser, transmettre, communiquer au public ou utiliser un contenu de notre Site de quelque manière que ce soit, sauf pour votre usage personnel sans caractère commercial."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v("8. CONFIANCE DANS LES INFORMATIONS AFFICHEES SUR LE SITE"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les commentaires et autres éléments affichés sur notre Service ne sont pas destinés à être considérés comme des conseils auxquels on peut faire confiance. Nous déclinons par conséquent toute responsabilité au titre de la confiance accordée à ces éléments par les visiteurs de notre Service ou par quiconque susceptible d'être informé de son contenu."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "9. ACTUALISATIONS REGULIERES DE NOTRE SITE ET DE NOTRE SERVICE"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous souhaitons mettre régulièrement à jour notre Site et notre Service et pouvons en modifier le contenu à tout moment. En cas de nécessité, nous pouvons suspendre l'accès à notre Site et à notre Service ou les fermer pour une durée indéterminée. Les éléments de notre Site ou notre Service peuvent être dépassés à un moment donné et nous ne sommes en aucun cas tenus d'actualiser ces éléments."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("10. NOTRE RESPONSABILITE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous avons préparé très soigneusement notre Site et notre Service. Cependant, nous ne sommes pas responsables des éventuelles erreurs ou omissions en rapport avec ledit contenu et des éventuels problèmes techniques que vous pouvez rencontrer avec notre Site ou notre Service. Si nous sommes informés d'inexactitudes sur notre Site ou dans notre Service, nous essaierons de les corriger dès que cela sera raisonnablement possible. Dans les limites autorisées par la loi, nous excluons toute responsabilité (contractuelle, au titre de la négligence ou autre) dans une perte ou un dommage que vous ou un tiers pourriez subir en liaison avec notre Site, notre Service et tout Site web lié à notre Site et les éléments affichés sur le Site. Cela ne concerne pas notre responsabilité en matière de décès ou de blessures corporelles dû(dues) à notre négligence ni notre responsabilité en matière de déclaration frauduleuse ou de déclaration inexacte sur un sujet fondamental ni une autre responsabilité qui ne peut pas être exclue ou limitée selon la législation applicable."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "11. INFORMATIONS RELATIVES A VOUS ET A VOS VISITES SUR NOTRE SITE ET A L'UTILISATION DE NOTRE SERVICE"
          ),
        ]),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "12. TELECHARGEMENT DE DONNEES SUR NOTRE SITE ET NOTRE SERVICE"
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("13. LIENS DE NOTRE SITE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Lorsque notre Site contient des liens vers d'autres sites et ressources fournis par des tiers, ces liens sont donnés à titre d'information uniquement. Nous ne contrôlons pas le contenu de ces Sites et ressources et déclinons toute responsabilité liée à ce contenu ou en matière de perte ou dommage susceptible de découler de votre utilisation de ce contenu."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("14. COMPETENCE ET LEGISLATION APPLICABLE")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les tribunaux français ont compétence pour toutes les plaintes découlant de ou liées à une consultation de notre Site ou à une utilisation de nos Services. Les présentes conditions d'utilisation et tout conflit ou plainte découlant de ou lié(e) à ces conditions d'utilisation ou leur objet ou formation (dont les conflits ou plaintes non contractuel(le)s) doivent être régis par et interprétés conformément au droit français."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("15. MODIFICATIONS")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nous pouvons réviser les présentes conditions d'utilisation à tout moment en modifiant cette page. Vous êtes censé vérifier cette page de temps à autre pour prendre connaissance des modifications que nous avons apportées car elles sont contraignantes pour vous."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("16. VOS PREOCCUPATIONS")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Si vous avez des préoccupations au sujet de données qui figurent dans notre Service, veuillez prendre contact avec contact@clyosystems.com"
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("ENSEMBLE DES CONDITIONS GÉNÉRALES")]),
        _vm._v(" "),
        _vm._m(14),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        'SUD INFORMATIQUE SERVICES est une société dans laquelle les repas sont préparés par des restaurants indépendants (nos "Restaurants partenaires" ) et livrés par nous. '
      ),
      _c("br"),
      _vm._v("\n Vous pouvez nous contacter :"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Mail : "),
      _c("a", { attrs: { href: "mailto:contact@clyosystems.com" } }, [
        _vm._v("contact@clyosystems.com"),
      ]),
      _c("br"),
      _vm._v("\n Téléphone : 04 88 91 60 80 "),
      _c("br"),
      _vm._v("\n Adresse : 60 Avenue de Nice, 06800 Cagnes sur Mer - France "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Chaque commande donne lieu à un descriptif récapitulant les caractéristiques des Repas commandés, leurs prix, le prix de la livraison ainsi que le prix global de la commande. "
      ),
      _c("br"),
      _vm._v(
        "\n Par l’acceptation de ce récapitulatif, vous vous engagez au paiement de la commande. Cette obligation vous est rappelée par la mention « commande avec obligation de paiement ». "
      ),
      _c("br"),
      _vm._v(
        "\n Toute commande, après confirmation de votre part, ne sera définitive qu’après confirmation du paiement. Aucune livraison n’interviendra sans paiement. "
      ),
      _c("br"),
      _vm._v(
        '\n Quand vous passez une commande par le biais de notre Service, nous vous envoyons, pour le compte du restaurant partenaire, un e-mail vous remerciant de votre commande et confirmant que celle-ci a été reçue et acceptée par le Restaurant partenaire (l\'"E-mail de confirmation" ). Cet e-mail vous informera sur les délais de la livraison, le montant et l’objet de la commande. '
      ),
      _c("br"),
      _vm._v(
        "\n Le contrat de fourniture de tout Repas que vous commandez par notre intermédiaire est conclu entre vous et le Restaurant partenaire et n’est conclu qu’à compter de l’envoi de l'E-mail de confirmation. "
      ),
      _c("br"),
      _vm._v(
        "\n Nous vous remercions de vérifier que l'adresse électronique que vous avez nous donnée est correcte car c'est elle qui nous permettra de communiquer avec vous au sujet de votre commande. "
      ),
      _c("br"),
      _vm._v(
        "\n Nous vous remercions de vérifier également que vous donnez une adresse et un numéro de téléphone exacts, afin de garantir que vos Repas soient livrés au bon endroit. Si vous n'ouvrez pas la porte et ne répondez pas au téléphone dans les 10 minutes suivant l'arrivée de notre chauffeur-livreur à votre adresse, nous nous réservons le droit de partir et de vous facturer le Repas. "
      ),
      _c("br"),
      _vm._v(
        "\n SUD INFORMATIQUE SERVICES souhaite fournir un service de qualité et est votre premier interlocuteur en cas de problème avec votre Repas, qu'il concerne la qualité ou la température des repas. Nous contrôlons très attentivement nos Restaurants partenaires et il est extrêmement important pour nous qu'ils respectent nos normes et nous aident à maintenir notre réputation. "
      ),
      _c("br"),
      _vm._v(
        "\n Merci de nous communiquer vos commentaires éventuels au sujet de nos Restaurants partenaires ou des Repas par e-mail ou par téléphone. "
      ),
      _c("br"),
      _vm._v(
        "\n A travers le processus de prise de commande, vous acceptez expressément l’application des présentes conditions générales de prestations de service. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Tous les Repas sont sous réserve de disponibilité. Votre Restaurant partenaire peut proposer une solution de remplacement pour un Repas que nous ne pouvons vous fournir. "
      ),
      _c("br"),
      _vm._v(
        "\n Nos Restaurants partenaires peuvent utiliser des noix dans la préparation de certains Repas. "
      ),
      _c("br"),
      _vm._v(
        "\n Veuillez appeler notre restaurant partenaire avant de passer commande si vous souffrez d'allergie. SUD INFORMATIQUE SERVICES ne peut pas garantir que les Repas vendus par nos Restaurants partenaires sont sans allergène. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("6.1")]),
      _vm._v(
        " Les boissons alcoolisées ne peuvent être vendues qu'aux personnes de plus de 18 ans et une preuve peut être exigée (article L3342-1 du Code de la santé publique). SUD INFORMATIQUE SERVICES se réserve le droit de refuser de fournir de l'alcool à toute personne qui semble avoir moins de 18 ans ou qui est ou semble sous l'influence de l'alcool ou de médicaments. En passant une commande qui contient de l'alcool, vous confirmez que vous avez au moins 18 ans. Toute violation du présent article engage votre responsabilité personnelle exclusive."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("6.2")]),
      _vm._v(
        " L’abus d’alcool est dangereux pour la santé. Sachez consommer et apprécier avec modération. Par le seul fait de passer commande sur notre « site internet », vous renoncez expressément au bénéfice de l’article 1587 du Code civil qui prévoit que la conclusion de la vente de vin ne devient définitive qu’après dégustation et agrément de l’acheteur."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Notre objectif est la fourniture du meilleur service de livraison possible. "
      ),
      _c("br"),
      _vm._v(
        "\n Malheureusement, les choses ne se déroulent pas toujours comme prévu et des aléas comme les conditions de circulation ou les conditions météorologiques peuvent parfois nous empêcher d'atteindre nos objectifs à cet égard. Nous faisons tout notre possible pour garantir la livraison de votre Repas dans le délai indiqué dans l'e-mail et sur la page Web. "
      ),
      _c("br"),
      _vm._v(
        "\n Le délai de livraison de votre commande est établi en fonction du nombre de commandes et des conditions auxquelles est soumis le restaurant partenaire à ce moment. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        'Vous avez le droit d\'annuler une commande dans un délai raisonnable et avant que la commande devienne une commande lancée. Un restaurant partenaire classe comme "commande défaillante" une commande qui est annulée après que des aliments ont été utilisés pour commencer sa préparation ( "commande lancée" ). Les clients peuvent annuler une commande en prenant contact avec le Restaurant partenaire. SUD INFORMATIQUE SERVICES et le Restaurant partenaire peuvent annuler une commande et vous en informent dans ce cas. Les commandes annulées conformément à cette clause ne vous sont pas facturées. Tout règlement effectué avant l\'annulation d\'une commande par SUD INFORMATIQUE SERVICES ou un restaurant partenaire est généralement remboursé par le même moyen que celui que vous avez utilisé pour payer votre commande. Chaque commande annulée après être devenue une Commande lancée vous est facturée. SUD INFORMATIQUE SERVICES seul établit si une commande est ou non une Commande lancée. '
      ),
      _c("br"),
      _vm._v(
        "\n Vous ne disposez pas de droit de rétractation, en vertu des dispositions de l’article L121-21-8 alinéa 4 du Code de la consommation, les Repas, objets du contrat étant des denrées périssables. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Le prix des Repas est indiqué dans notre service. Les prix sont TTC et incluent la TVA et les coûts de livraison. Les prix varient selon les menus. Les prix sont susceptibles d'être révisés à tout moment mais les modifications ne s'appliquent pas aux commandes pour lesquelles vous avez reçu l'e-mail de confirmation, sauf s'il y a une erreur manifeste sur le prix : dans ce cas, nous vous avertissons dès que possible du problème de prix. Vous pouvez annuler votre commande lorsque nous vous informons de l'erreur. Malgré tous nos efforts, le prix de certains Repas figurant dans notre service peut être erroné. Le Restaurant partenaire concerné vérifie normalement ses prix dans le cadre du processus de passation de commande. "
      ),
      _c("br"),
      _vm._v(
        "\n Tous les Repas peuvent être réglés par carte bancaire par le biais de notre Service. "
      ),
      _c("br"),
      _vm._v(
        "\n Sont acceptés comme moyens de paiement : les cartes de crédit, carte bancaire, (visa, mastercard etc.). "
      ),
      _c("br"),
      _vm._v("\n Précisez si vous avez un système de paiement sécurisé "),
      _c("br"),
      _vm._v(
        "\n En acceptant de contracter sur la base des présentes conditions, vous reconnaissez explicitement votre obligation de paiement. Une fois que votre commande a été confirmée, votre carte de crédit reçoit une autorisation de débit et le montant est réservé pour être débité. "
      ),
      _c("br"),
      _vm._v(
        "\n Le règlement est effectué directement à SUD INFORMATIQUE SERVICES qui le transmet ensuite au restaurant partenaire. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        'Dans les limites autorisées par la loi, SUD INFORMATIQUE SERVICES fournit son Service et son contenu "en l\'état" et "en fonction de la disponibilité". '
      ),
      _c("br"),
      _vm._v(
        "\n Selon les dispositions ci-dessous, ni SUD INFORMATIQUE SERVICES ni quelque Restaurant partenaire que ce soit n'ont de responsabilité vis-à-vis de vous en ce qui concerne des pertes directes, indirectes, particulières ou des dommages d'ordre contractuel, dus à un préjudice (dont la négligence) ou par ailleurs découlant de votre utilisation ou de votre incapacité à utiliser notre Service. Si la responsabilité de SUD INFORMATIQUE SERVICES ou du Restaurant partenaire est engagée vis-à-vis de vous, notre responsabilité totale cumulée est limitée au prix d'achat des Repas que vous avez payés dans votre commande. Cela ne comprend pas et ne limite en aucune manière la responsabilité de SUD INFORMATIQUE SERVICES ou d'un restaurant partenaire sur un sujet pour lequel il serait illégal que nous excluions ou tentions d'exclure ou qu'il exclue ou tente d'exclure notre ou sa responsabilité, en particulier, la responsabilité dans un décès ou des blessures corporelles dû (dues) à la négligence ou à une fraude ou à une déclaration frauduleuse. "
      ),
      _c("br"),
      _vm._v(
        "\n Le contrat de vente est conclu entre vous et le Restaurant. Le Restaurant partenaire que vous choisissez est un commerçant indépendant, distinct de notre société et sur lequel nous n’avons aucun contrôle. En conséquence, en dehors des strictes conditions légales, notre responsabilité ne saurait être engagée à ce titre. "
      ),
      _c("br"),
      _vm._v(
        "\n Le Restaurant partenaire, vendeur, est tenu des défauts de conformité du bien au contrat dans les conditions de l’article L 211-4 du Code de la consommation et des défauts de la chose vendue en cas de vices cachés (article 1641 Code civil) et de la garantie légale de conformité (article L211-4 et suivant Code de la consommation). "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        'clyosystems.com est un Site web exploité par Sud informatique Services ("nous" ou "CLYO SYSTEMS"), société forme sociale SARL au capital de 10 000 euros immatriculée en France au RCS sous le n° 489 418 053, dont le siège social est situé au 60 Avenue de Nice, 06800 Cagnes sur Mer, France. Notre numéro de TVA FR91489418053. Sud informatique Services est une société dans laquelle les repas sont préparés par des restaurants indépendants (nos "Restaurants partenaires") et livrés par nous. '
      ),
      _c("br"),
      _vm._v("\n Vous pouvez nous contacter : "),
      _c("br"),
      _vm._v("\n Mail : "),
      _c("a", { attrs: { href: "mailto:contact@clyosystems.com" } }, [
        _vm._v("contact@clyosystems.com"),
      ]),
      _c("br"),
      _vm._v("\n Téléphone : 04 88 91 60 80 "),
      _c("br"),
      _vm._v("\n Adresse : 60 Avenue de Nice, 06800 Cagnes sur Mer, France "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "contenir des éléments diffamatoires pour une personne, obscènes, injurieux, haineux ou incendiaires, promouvoir des scènes explicites sur le plan sexuel ou promouvoir la violence ou promouvoir la discrimination sur la base de la race, du sexe, de la religion, de la nationalité, du handicap, de l'orientation sexuelle ou de l'âge ;"
        ),
      ]),
      _vm._v(
        "\n\t enfreindre des droits d’auteur, droits sur des bases de données ou marques de commerce d'un tiers ;"
      ),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "être susceptibles de tromper un tiers ou être en infraction avec une obligation légale vis-à-vis d'un tiers, comme une obligation contractuelle ou une obligation de discrétion ou promouvoir une activité illégale ;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "être menaçantes, porter atteinte à ou violer l'intimité d'un tiers, provoquer une gêne, un dérangement ou une anxiété inutile ou être susceptibles de harceler, perturber, embarrasser, alarmer ou gêner un tiers ;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "être utilisées pour se faire passer pour quelqu'un d'autre ou usurper votre identité ou tromper sur votre affiliation avec une personne ou donner l'impression qu'elles émanent de nous, si tel n'est pas le cas ou"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "préconiser, promouvoir ou aider à un acte illégal comme (à titre d'exemple uniquement) une violation de droit d’auteur ou un piratage d'ordinateur."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "suppression immédiate, temporaire ou permanente de votre droit d'utiliser notre Service ;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "suppression immédiate, temporaire ou permanente des contributions ou éléments téléchargés par vous sur notre Service ;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("envoi d'un avertissement à votre encontre ;")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "action en justice contre vous, comprenant une procédure en vue du remboursement de tous les coûts (dont, de manière non exhaustive, les coûts administratifs et les frais de justice raisonnables) entraînés par l'infraction ;"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "communication de ces informations aux autorités chargées de l'application des lois si nous l'estimons légitimement nécessaire."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Les réactions décrites dans cette clause ne sont pas exhaustives et nous pouvons prendre toutes les autres mesures que nous jugeons légitimement adaptées. Le nom du responsable de la publication et les motifs de retrait apparaitront sur le Site."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Nous collectons certaines données à votre sujet dans le cadre de votre utilisation de notre Service. Ce point est décrit de manière plus détaillée dans notre politique de respect de la vie privée. "
      ),
      _c("br"),
      _vm._v(
        "\n Notre numéro de déclaration à la CNIL est en cours d’attribution. "
      ),
      _c("br"),
      _vm._v(
        "\n Concernant les cookies, un bandeau informe les internautes de leur finalité, qui pourront les refuser ou les accepter. La durée maximum de ce consentement étant de 13 mois."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Sauf indication contraire, toute réduction, tout bon ou code, sera applicable uniquement sur les premières commandes effectuées par de nouveaux clients de Sud informatique Services."
      ),
      _c("br"),
      _vm._v(
        "\n Un nouveau client est défini comme étant une personne qui s'inscrit, qui choisit une sélection de repas et qui saisit le code promotionnel ou de réduction indiqué sur une publicité, un coupon ou un dépliant, lors de son passage en caisse ou durant la commande."
      ),
      _c("br"),
      _vm._v(
        "\n Toutes les dates de validité des promotions sont spécifiées sur les annonces, coupons ou dépliants. Veuillez-vous reporter aux conditions résumées sur ces supports pour obtenir des informations exactes et spécifiques concernant cette promotion et sa période promotionnelle."
      ),
      _c("br"),
      _vm._v(
        "\n Tout alcool sera fourni uniquement aux personnes âgées de 18 ans ou plus."
      ),
      _c("br"),
      _vm._v(
        "\n Toute réduction, tout coupon ou code est limité à un seul usage par commande, et chaque réduction, coupon ou code ne peut être utilisé qu'une seule fois par personne."
      ),
      _c("br"),
      _vm._v(
        "\n Aucune réduction, aucun coupon ou code ne peut être utilisé en conjonction avec une autre offre SUD INFORMATIQUE SERVICES quelle qu'elle soit."
      ),
      _c("br"),
      _vm._v(
        "\n Aucune réduction, aucun coupon ou code ne peut être échangé contre de l'argent ou toute autre alternative ; ils n'ont en outre aucune valeur monétaire."
      ),
      _c("br"),
      _vm._v(
        "\n L'annulation de toute commande entraînera l'invalidation du code utilisé sur le compte concerné."
      ),
      _c("br"),
      _vm._v(
        "\n Toute réduction, tout bon ou code est utilisable uniquement pour une même commande, tout crédit restant après déduction de cette réduction, de ce coupon ou de ce code ne pourra pas être reporté sur des commandes supplémentaires ou ultérieures."
      ),
      _c("br"),
      _vm._v(
        "\n Les réductions, bons ou codes pourraient être fournis sur la base d'un service clients et seront appliqués sur le compte client sous forme de crédit à utiliser en une seule commande."
      ),
      _c("br"),
      _vm._v(
        "\n Toute tentative de manipulation du système et d'utilisation des réductions, bons ou codes par le biais de soumissions en vrac, de tiers ou de syndicats, de macros, d'un « script », de l'approche dite de « force brute », en masquant son identité grâce à une manipulation des adresses IP, en utilisant des identités autres que la sienne, ou tout autre moyen automatisé (y compris les systèmes programmables dans le but de générer des soumissions), rendra la commande et l'utilisation de ces réductions, bons ou codes invalide et pourrait potentiellement conduire à la clôture dudit compte."
      ),
      _c("br"),
      _vm._v(
        "\n Si pour un motif quelconque, une réduction, un bon ou un code devient invalide à cause de problèmes techniques ou de toute autre raison échappant au contrôle de SUD INFORMATIQUE SERVICES ou si un repas ou un restaurant est indisponible, Sud informatique Services se réserve le droit (sous réserve de quelconques dispositions écrites stipulées aux termes de la loi applicable) d'annuler, de suspendre ou de modifier la campagne liée à cette réduction, ce bon ou ce code, sans réémettre de réduction, bon ou code supplémentaire aux clients affectés."
      ),
      _c("br"),
      _vm._v(
        "\n Le cas échéant, Sud informatique Services se réserve le droit de prendre toutes les mesures qu'il considérera raisonnables pour se protéger contre les réclamations frauduleuses ou non valides, y compris, sans limitation, le droit d'exiger une vérification supplémentaire quant à l'identité du gagnant, son âge, et autres détails pertinents."
      ),
      _c("br"),
      _vm._v(
        "\n En utilisant cette réduction, ce bon ou ce code, les clients acceptent de dégager Sud informatique Services de toute responsabilité en cas de réclamations, frais, blessures, pertes ou dommages de quelque nature qu'ils soient, résultant de cette campagne ou y étant liés ou résultant de l'acceptation ou de la possession de toute commande (sauf en cas de décès ou de blessures corporelles causés par la négligence du Promoteur, de fraude ou de toute action autrement interdite par la loi)."
      ),
      _c("br"),
      _vm._v(
        "\n Tous les repas et les restaurants sont proposés sous réserve de disponibilité."
      ),
      _c("br"),
      _vm._v(
        "\n L'inscription et les conditions générales standard de Sud informatique Services sont applicables - veuillez-vous y reporter sur cette page pour tout complément d'information."
      ),
      _c("br"),
      _vm._v(
        "\n Sud informatique Services utilisera les données personnelles fournies sur le compte du client et lors des commandes, uniquement à des fins de gestion et de livraison de la commande et à aucune autre fin, sauf si nous avons obtenu votre consentement. Il Sud informatique Services se réserve le droit de divulguer les données personnelles du client à ses prestataires, afin de permettre la livraison d'une commande ou en réponse à une question de la part d'un client. Pour tout complément d'informations sur la manière dont nous stockons-les données de nos clients, veillez consulter www.eatself.com/privacy pour visualiser notre politique de confidentialité des données."
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }